export default {
  errorTitle: 'Désolé',
  errorMsg: 'Certains éléments de la page n’ont pas été chargés.',
};
